const BASE_URL = 'https://ongs.alkemy.org/fortalecer/';

export default BASE_URL;